import React from 'react';
import { Box, Typography, Container, Grid, IconButton, Link } from '@mui/material';
import { Facebook, Twitter, Pinterest, YouTube, Instagram } from '@mui/icons-material';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#000', // Dark background
        color: 'white',
        pt: 4,
        pb: 2,
      }}
    >
      <Container maxWidth="lg">
        {/* Main Content */}
        <Grid container spacing={4} textAlign="center">
          {/* Address Section */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              // borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
              py: 2, // Vertical padding
              px: 3, // Horizontal padding
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#9ca89b', mb: 1 }}>
              ADDRESS
            </Typography>
            <Typography variant="body2">Number 969, knuckles Estate, Thawalanthanna, Sri Lanka

             </Typography>
          </Grid>

          {/* Phone Section */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
              py: 2,
              px: 3,
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#9ca89b', mb: 1 }}>
              PHONE
            </Typography>
            <Typography variant="body2">+94 776 718 674</Typography>
          </Grid>

          {/* Email Section */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              borderRight: '1px solid rgba(255, 255, 255, 0.2)',
              borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
              py: 2,
              px: 3,
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#9ca89b', mb: 1 }}>
              EMAIL
            </Typography>
            <Typography variant="body2">
              <a
                href="https://mail.google.com/mail/u/0/?fs=1&to=hotel@unseen.travel&tf=cm"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  color: 'inherit',
                  fontWeight: 'normal',
                }}
              >
                info@unseen.travel
              </a>
            </Typography>

          </Grid>

          {/* Social Section */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              // borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
              py: 2,
              px: 3,
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#9ca89b', mb: 1 }}>
              SOCIAL
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
              <IconButton href="#" target="_blank" sx={iconButtonStyle}>
                <Facebook />
              </IconButton>
              
              
              <IconButton href="https://youtu.be/_vbc7RUfBQU" target="_blank" sx={iconButtonStyle}>
                <YouTube />
              </IconButton>
              <IconButton href="#" target="_blank" sx={iconButtonStyle}>
                <Instagram />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Content */}
        <Box
          sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            mt: 4,
            pt: 2,
            textAlign: 'center',
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.875rem',
          }}
        >
          <Typography variant="body2" gutterBottom>
            © Copyright for RTA.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, mt: 1 }}>
            <Link href="#" underline="none" sx={bottomLinkStyle}>
              PRIVACY
            </Link>
            <Link href="#" underline="none" sx={bottomLinkStyle}>
              TERMS OF USE
            </Link>
            <Link href="#" underline="none" sx={bottomLinkStyle}>
              POLICY
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

// Styles for social media icons
const iconButtonStyle = {
  color: 'white',
  '&:hover': {
    color: '#9ca89b', // Slight greenish tint on hover
  },
};

const bottomLinkStyle = {
  color: 'rgba(255, 255, 255, 0.7)',
  fontSize: '0.875rem',
  '&:hover': {
    color: 'white',
  },
};

export default Footer;
